require('bootstrap');
require('bootstrap/dist/css/bootstrap.css');
require('font-awesome/css/font-awesome.css');
require('summernote/dist/summernote.css');
require('summernote/dist/summernote.js');
require('ng-sortable/dist/ng-sortable.min.css');
require('angular-summernote');
require('ng-sortable');

const emailEditorModule = require('gw-um-email-editor/emailEditorModule.js');

/*@ngInject*/
angular.module('gw-um-submission', [
    'ngSanitize',
    'ngIdle',
    'ui.router',
    'ui.bootstrap',
    'ui.select',
    'relativeDate',
    'currencyFilter',
    'isoCurrency',
    'summernote',
    'dibari.angular-ellipsis',
    'umCore',
    'ux',
    'as.sortable',
    'umConfig',
    'gw-um-header',
    emailEditorModule
])
    .config(function ($stateProvider, moduleConfigConstant) {
        _.each(moduleConfigConstant.submission.routes, (state, stateName) => {
            $stateProvider.state(stateName, state);
        });
    })
    .run(function ($rootScope, moduleConfigConstant) {
        $rootScope.config = moduleConfigConstant.submission;
    });

require('./submissionController');
require('./submissionMediator');
require('./submissionStateMediator');
require('./submissionStateModel');
require('./submissionUtil');
require('./submission.tpl.html');
require('./submission.less');

require('./account/assign/assignAccountModal.less');
require('./account/assign/assignAccountModal.tpl.html');
require('./account/assign/assignAccountModalController');

require('./account/grid/accountGridComponent');
require('./account/grid/accountGridController');
require('./account/grid/accountGrid.tpl.html');
require('./account/grid/accountGrid.less');

require('./account/repository/assignAccountRepository');
require('./account/repository/createAccountRepository');
require('./account/repository/getAccountRepository');
require('./account/repository/getAccountsByFilterUriRepository');
require('./account/repository/validateAccountRepository');
require('./account/accountMediator');

require('./activeSubmissionDropdown/activeSubmissionDropdown.i18n.json');
require('./activeSubmissionDropdown/activeSubmissionDropdown.less');
require('./activeSubmissionDropdown/activeSubmissionDropdown.tpl.html');
require('./activeSubmissionDropdown/activeSubmissionDropdownComponent');
require('./activeSubmissionDropdown/activeSubmissionDropdownController');

require('./checklist/checklist.less');
require('./checklist/checklist.tpl.html');
require('./checklist/checklistController');
require('./checklist/checklistMediator');
require('./checklist/getChecklistItemsRepository');
require('./checklist/updateChecklistItemRepository');

require('./collaboration/attachment/fileTemplateModal/fileTemplateModal.less');
require('./collaboration/attachment/fileTemplateModal/fileTemplateModal.tpl.html');
require('./collaboration/attachment/fileTemplateModal/fileTemplateModalController');

require('./collaboration/attachment/collaborationAttachment.less');
require('./collaboration/attachment/collaborationAttachment.tpl.html');
require('./collaboration/attachment/collaborationAttachmentController');
require('./collaboration/attachment/loadSubmissionAttachmentsRepository');

require('./collaboration/chat/collaborationChat.less');
require('./collaboration/chat/collaborationChat.tpl.html');
require('./collaboration/chat/collaborationChatController');

require('./collaboration/chat/inviteChat/inviteChatModal.less');
require('./collaboration/chat/inviteChat/inviteChatModal.tpl.html');
require('./collaboration/chat/inviteChat/inviteChatModalController');

require('./collaboration/chat/repository/chatMessageListRepository');
require('./collaboration/chat/repository/inviteChatRepository');
require('./collaboration/chat/repository/publishChatMessageRepository');
require('./collaboration/chat/repository/sendChatMessageRepository');
require('./collaboration/chat/repository/unpublishChatMessageRepository');

require('./collaboration/email/collaborationEmail.less');
require('./collaboration/email/collaborationEmailController');
require('./collaboration/email/collaborationEmail.tpl.html');

require('./collaboration/email/emailEditor/emailEditorModal.less');
require('./collaboration/email/emailEditor/emailEditorModal.tpl.html');
require('./collaboration/email/emailEditor/emailEditorModalController');
require('./collaboration/email/emailEditor/propertiesFilter');


require('./collaboration/email/emailTemplateModal/emailTemplateModal.less');
require('./collaboration/email/emailTemplateModal/emailTemplateModal.tpl.html');
require('./collaboration/email/emailTemplateModal/emailTemplateModalController');

require('./collaboration/email/emailViewer/emailViewerModal.less');
require('./collaboration/email/emailViewer/emailViewerModal.tpl.html');
require('./collaboration/email/emailViewer/emailViewerModalController');

require('./collaboration/email/repository/collaborationEmailRepository');
require('./collaboration/email/repository/createCorrespondenceEmailRepository');
require('./collaboration/email/repository/createCorrespondenceFormRepository');
require('./collaboration/email/repository/deleteCollaborationEmailRepository');
require('./collaboration/email/repository/forwardCollaborationEmailRepository');
require('./collaboration/email/repository/hideSharedCollaborationRepository');
require('./collaboration/email/repository/replyAllCollaborationEmailRepository');
require('./collaboration/email/repository/replyCollaborationEmailRepository');
require('./collaboration/email/repository/sendCollaborationEmailRepository');
require('./collaboration/email/repository/updateCollaborationEmailRepository');
require('./collaboration/email/repository/uploadAttachmentCollaborationEmailRepository');

require('./collaboration/note/collaborationNote.less');
require('./collaboration/note/collaborationNote.tpl.html');
require('./collaboration/note/collaborationNoteController');
require('./collaboration/note/collaborationNoteEditor.tpl.html');
require('./collaboration/note/collaborationNoteEditorComponent');
require('./collaboration/note/collaborationNoteEditorController');

require('./collaboration/note/repository/collaborationNoteRepository');
require('./collaboration/note/repository/createCollaborationNoteRepository');
require('./collaboration/note/repository/deleteCollaborationNoteRepository');
require('./collaboration/note/repository/updateCollaborationNoteRepository');

require('./collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.less');
require('./collaboration/task/newTaskAttachmentModal/newTaskAttachmentModal.tpl.html');
require('./collaboration/task/newTaskAttachmentModal/newTaskAttachmentModalController');

require('./collaboration/task/repository/collaborationCreateTaskRepository');
require('./collaboration/task/repository/collaborationDeleteTaskRepository');
require('./collaboration/task/repository/collaborationLoadTaskRepository');
require('./collaboration/task/repository/collaborationNotifyTaskRepository');
require('./collaboration/task/repository/collaborationUpdateTaskRepository');

require('./collaboration/task/taskCalendar/taskCalendar.less');
require('./collaboration/task/taskCalendar/taskCalendar.tpl.html');
require('./collaboration/task/taskCalendar/taskCalendarComponent');
require('./collaboration/task/taskCalendar/taskCalendarController');
require('./collaboration/task/taskCalendar/taskCalendarFocusDirective');

require('./collaboration/task/collaborationTask.less');
require('./collaboration/task/collaborationTask.tpl.html');
require('./collaboration/task/collaborationTaskController');
require('./collaboration/task/collaborationTaskEditor.tpl.html');
require('./collaboration/task/collaborationTaskEditorController');

require('./collaboration/collaboration.less');
require('./collaboration/collaboration.tpl.html');
require('./collaboration/collaborationController');
require('./collaboration/collaborationMediator');
require('./collaboration/collaborationRepository');
require('./collaboration/collaborationUserAvatar.tpl.html');
require('./collaboration/collaborationUserAvatarDirective');
require('./collaboration/collaborationUtil');

require('./component/status/submissionStatus.less');
require('./component/status/submissionStatus.tpl.html');
require('./component/status/submissionStatusComponent');
require('./component/status/submissionStatusController');

require('./content/accountSubmissionsGrid/accountSubmissions.tpl.html');
require('./content/accountSubmissionsGrid/accountSubmissionsController');
require('./content/accountSubmissionsGrid/accountSubmissionsGrid.less');
require('./content/accountSubmissionsGrid/accountSubmissionsGrid.tpl.html');
require('./content/accountSubmissionsGrid/accountSubmissionsGridComponent');
require('./content/accountSubmissionsGrid/accountSubmissionsGridController');
require('./content/accountSubmissionsGrid/accountSubmissionsGridRepository');

require('./content/document/document.tpl.html');
require('./content/document/documentController');

require('./content/externalContent/directives/contentIframe');
require('./content/externalContent/directives/contentIframe.less');
require('./content/externalContent/directives/contentIframe.tpl.html');

require('./content/externalContent/externalContent.less');
require('./content/externalContent/externalContent.tpl.html');
require('./content/externalContent/externalContentController');

require('./content/gridTotals/gridTotals.less');
require('./content/gridTotals/gridTotals.tpl.html');
require('./content/gridTotals/gridTotalsComponent');
require('./content/gridTotals/gridTotalsController');

require('./content/overview/activity/activityStream.less');
require('./content/overview/activity/activityStream.tpl.html');
require('./content/overview/activity/activityStreamController');
require('./content/overview/activity/activityStreamRepository');

require('./content/policiesSummaryGrid/policiesSummary.tpl.html');
require('./content/policiesSummaryGrid/policiesSummaryController');
require('./content/policiesSummaryGrid/policiesSummaryGrid.less');
require('./content/policiesSummaryGrid/policiesSummaryGrid.tpl.html');
require('./content/policiesSummaryGrid/policiesSummaryGridComponent');
require('./content/policiesSummaryGrid/policiesSummaryGridController');
require('./content/policiesSummaryGrid/policiesSummaryGridRepository');

require('./content/print/printOverview.less');
require('./content/print/printHeader.tpl.html');
require('./content/print/printOverview.tpl.html');
require('./content/print/printCollaboration.tpl.html');
require('./content/print/printOverviewController');

require('./content/proposalSummaries/proposalSummaries.less');
require('./content/proposalSummaries/proposalSummaries.tpl.html');
require('./content/proposalSummaries/proposalSummariesController');

require('./content/proposalSummary/proposalSummary.less');
require('./content/proposalSummary/proposalSummary.tpl.html');
require('./content/proposalSummary/proposalSummaryController');

require('./content/quoteSummaries/quoteSummaries.less');
require('./content/quoteSummaries/quoteSummaries.tpl.html');
require('./content/quoteSummaries/quoteSummariesController');

require('./content/reportsSummary/reportsSummary.less');
require('./content/reportsSummary/reportsSummary.tpl.html');
require('./content/reportsSummary/reportsSummaryController');

require('./create/createSubmissionModal.less');
require('./create/createSubmissionModal.tpl.html');
require('./create/createSubmissionModalController');

require('./detailedHistory/detailedHistoryGridColumnModel');
require('./detailedHistory/detailedHistoryModal.less');
require('./detailedHistory/detailedHistoryModal.tpl.html');
require('./detailedHistory/detailedHistoryModalController');
require('./detailedHistory/detailedHistoryRepository');
require('./detailedHistory/historyGrid.less');
require('./detailedHistory/historyGrid.tpl.html');
require('./detailedHistory/historyGridComponent');
require('./detailedHistory/historyGridController');

require('./form/submissionFormViewer.less');
require('./form/submissionFormViewer.tpl.html');
require('./form/submissionFormViewerController');

require('./model/currentSubmissionModel');

require('./modification/detail/modificationDetail.less');
require('./modification/detail/modificationDetail.tpl.html');
require('./modification/detail/modificationDetailController');

require('./modification/repository/acknowledgeModificationsRepository');
require('./modification/repository/discardModificationsRepository');
require('./modification/repository/modificationRepository');
require('./modification/repository/submitModificationsRepository');

require('./modification/reviewChanges/reviewChangesModal.less');
require('./modification/reviewChanges/reviewChangesModal.tpl.html');
require('./modification/reviewChanges/reviewChangesModalController');

require('./modification/modification.tpl.html');
require('./modification/modificationController');

require('./navigation/drawerSlideDirective');
require('./navigation/navigation.less');
require('./navigation/navigation.tpl.html');
require('./navigation/navigationController');
require('./navigation/navigationMenu.less');
require('./navigation/navigationRepository');
require('./navigation/navigationUtil');

require('./newAttachmentModal/newAttachmentModal.less');
require('./newAttachmentModal/newAttachmentModal.tpl.html');
require('./newAttachmentModal/newAttachmentModalController');

require('./repository/formUpgradeCheckRepository');
require('./repository/formUpgradeRepository');
require('./repository/openSubmissionRepository');
require('./repository/proposalAttachmentRepository');
require('./repository/proposalListRepository');
require('./repository/proposalMediator');
require('./repository/proposalRepository');
require('./repository/quoteListRepository');
require('./repository/quoteMediator');
require('./repository/quoteRepository');
require('./repository/reportMediator');
require('./repository/reportRepository');
require('./repository/submissionRepository');

require('./snippets/snippetsViewer.less');
require('./snippets/snippetsViewer.tpl.html');
require('./snippets/snippetsViewerComponent');
require('./snippets/snippetsViewerController');
require('./snippets/snippetsViewerDraggableDirective');
require('./snippets/snippetsViewerResizableDirective');

require('./wizard/actions/approveEndorsement/approveEndorsementModal.less');
require('./wizard/actions/approveEndorsement/approveEndorsementModal.tpl.html');
require('./wizard/actions/approveEndorsement/approveEndorsementModalController');

require('./wizard/actions/bindActions/bindActionModal.less');
require('./wizard/actions/bindActions/bindActionModal.tpl.html');
require('./wizard/actions/bindActions/bindActionModalController');

require('./wizard/actions/copyProposal/copyProposalModal.less');
require('./wizard/actions/copyProposal/copyProposalModal.tpl.html');
require('./wizard/actions/copyProposal/copyProposalModalController');

require('./wizard/actions/documentBuilder/documentBuilderModal.less');
require('./wizard/actions/documentBuilder/documentBuilderModal.tpl.html');
require('./wizard/actions/documentBuilder/documentBuilderModalController');

require('./wizard/actions/repository/submissionActions/changeProductsRepository');
require('./wizard/actions/repository/submissionActions/checkClearanceRepository');
require('./wizard/actions/repository/submissionActions/clearReadySubmissionRepository');
require('./wizard/actions/repository/submissionActions/clearSubmissionRepository');
require('./wizard/actions/repository/submissionActions/copySubmissionRepository');
require('./wizard/actions/repository/submissionActions/createProposalRepository');
require('./wizard/actions/repository/submissionActions/declineSubmissionRepository');
require('./wizard/actions/repository/submissionActions/disableAutomationRepository');
require('./wizard/actions/repository/submissionActions/getQuotableProductTemplatesRepository');
require('./wizard/actions/repository/submissionActions/makeApplicationRepository');
require('./wizard/actions/repository/submissionActions/markSubmissionLostRepository');
require('./wizard/actions/repository/submissionActions/modifySubmissionRepository');
require('./wizard/actions/repository/submissionActions/prequalificationRepository');
require('./wizard/actions/repository/submissionActions/reactivateSubmissionRepository');
require('./wizard/actions/repository/submissionActions/referralRepository');
require('./wizard/actions/repository/submissionActions/referSubmissionRepository');
require('./wizard/actions/repository/submissionActions/rejectSubmissionRepository');
require('./wizard/actions/repository/submissionActions/renewalRepository');
require('./wizard/actions/repository/submissionActions/resubmitSubmissionRepository');
require('./wizard/actions/repository/submissionActions/rewriteSubmissionRepository');
require('./wizard/actions/repository/submissionActions/splitSubmissionRepository');
require('./wizard/actions/repository/submissionActions/updateStatusReasonRepository');
require('./wizard/actions/repository/submissionActions/createQuoteRepository');
require('./wizard/actions/repository/submissionActions/reevaluateSubmissionRepository');

require('./wizard/actions/repository/actionsMediator');
require('./wizard/actions/repository/declineMediator');
require('./wizard/actions/repository/markAsLostMediator');
require('./wizard/actions/repository/endorsementActionRepository');
require('./wizard/actions/repository/endorsementActionsMediator');
require('./wizard/actions/repository/endorsementActionsRepository');
require('./wizard/actions/repository/policyActionRepository');
require('./wizard/actions/repository/policyActionsMediator');
require('./wizard/actions/repository/policyActionsRepository');
require('./wizard/actions/repository/policyCancellationActionsMediator');
require('./wizard/actions/repository/policyCancellationActionsRepository');
require('./wizard/actions/repository/policyIssuanceActionsMediator');
require('./wizard/actions/repository/policyIssuanceActionsRepository');
require('./wizard/actions/repository/policyRewriteActionRepository');
require('./wizard/actions/repository/policyRewriteActionsMediator');
require('./wizard/actions/repository/policyRewriteActionsRepository');
require('./wizard/actions/repository/proposalActionRepository');
require('./wizard/actions/repository/proposalActionsMediator');
require('./wizard/actions/repository/proposalActionsRepository');
require('./wizard/actions/repository/quoteActionRepository');
require('./wizard/actions/repository/quoteActionsMediator');
require('./wizard/actions/repository/quoteActionsRepository');
require('./wizard/actions/repository/reportActionRepository');
require('./wizard/actions/repository/reportActionsRepository');
require('./wizard/actions/repository/reportActionsMediator');
require('./wizard/actions/repository/submissionActionsRepository');
require('./wizard/actions/repository/submissionPrequalificationMediator');

require('./wizard/actions/util/endorsementActionUtil');
require('./wizard/actions/util/policyActionUtil');
require('./wizard/actions/util/policyCancellationActionUtil');
require('./wizard/actions/util/policyIssuanceActionUtil');
require('./wizard/actions/util/policyRewriteActionUtil');
require('./wizard/actions/util/proposalActionUtil');
require('./wizard/actions/util/quoteActionUtil');
require('./wizard/actions/util/reportActionUtil');
require('./wizard/actions/util/submissionActionUtil');

require('./wizard/addDocumentAction/addDocumentActionModal.less');
require('./wizard/addDocumentAction/addDocumentActionModal.tpl.html');
require('./wizard/addDocumentAction/addDocumentActionModalController');

require('./wizard/breadcrumbs/breadcrumbs.less');
require('./wizard/breadcrumbs/breadcrumbs.tpl.html');
require('./wizard/breadcrumbs/breadcrumbsController');
require('./wizard/breadcrumbs/breadcrumbsDirective');
require('./wizard/breadcrumbs/breadcrumbsMediator');
require('./wizard/breadcrumbs/breadcrumbsRepository');

require('./wizard/changeProducts/changeProductsModal.less');
require('./wizard/changeProducts/changeProductsModal.tpl.html');
require('./wizard/changeProducts/changeProductsModalController');

require('./wizard/changeAgency/changeAgencyModal.less');
require('./wizard/changeAgency/changeAgencyModal.tpl.html');
require('./wizard/changeAgency/changeAgencyModalController');

require('./wizard/generateRatingAttachments/generateRatingAttachmentsModal.less');
require('./wizard/generateRatingAttachments/generateRatingAttachmentsModal.tpl.html');
require('./wizard/generateRatingAttachments/generateRatingAttachmentsModalController');

require('./wizard/proposalQuotableProduct/proposalQuotableProductModal.less');
require('./wizard/proposalQuotableProduct/proposalQuotableProductModal.tpl.html');
require('./wizard/proposalQuotableProduct/proposalQuotableProductModalController');

require('./wizard/quotableProductTemplates/quotableProductTemplatesModal.less');
require('./wizard/quotableProductTemplates/quotableProductTemplatesModal.tpl.html');
require('./wizard/quotableProductTemplates/quotableProductTemplatesModalController');

require('./wizard/quoteSelection/quoteSelectionModal.less');
require('./wizard/quoteSelection/quoteSelectionModal.tpl.html');
require('./wizard/quoteSelection/quoteSelectionModalController');

require('./wizard/reason/reasonModal.less');
require('./wizard/reason/reasonModal.tpl.html');
require('./wizard/reason/reasonModalController');

require('./wizard/reason/form/reasonFormModal.less');
require('./wizard/reason/form/reasonFormModal.tpl.html');
require('./wizard/reason/form/reasonFormModalController');

require('./wizard/selection/selectionModal.less');
require('./wizard/selection/selectionModal.tpl.html');
require('./wizard/selection/selectionModalController');

require('./wizard/splitSubmission/splitSubmissionModal.less');
require('./wizard/splitSubmission/splitSubmissionModal.tpl.html');
require('./wizard/splitSubmission/splitSubmissionModalController');

require('./wizard/copySubmission/copySubmissionModal.less');
require('./wizard/copySubmission/copySubmissionModal.tpl.html');
require('./wizard/copySubmission/copySubmissionModalController');

require('./wizard/rewriteSubmission/rewriteSubmissionModal.less');
require('./wizard/rewriteSubmission/rewriteSubmissionModal.tpl.html');
require('./wizard/rewriteSubmission/rewriteSubmissionModalController.js');

require('./wizard/util/wizardActionHandlerUtil');
require('./wizard/util/wizardActionUtil');

require('./wizard/wizard.less');
require('./wizard/wizard.tpl.html');
require('./wizard/wizardContextModel');
require('./wizard/wizardController');
require('./wizard/wizardMediator');

module.exports = 'gw-um-submission';
